// Action types for the Agency Fulfilment Call Bot store module (STSMPD-1323).

export const AGENCY_CALL_STATE_SET = 'AGENCY_CALL_STATE_SET'
export const AGENCY_CALL_STATE_CLEAR = 'AGENCY_CALL_STATE_CLEAR'
